<template>
  <div class="bio-upgrade-modal">
    <div class="w-100 text-right">
      <font-awesome-icon
        class="close-icon"
        :icon="['far', 'times']"
        @click="$emit('close')"
      />
    </div>
    <div
      class="d-flex flex-column justify-content-center align-items-center text-center"
    >
      <img src="/assets/images/rocket.svg" />
      <div class="text mt-3">
        {{ $t('BIO.TEXT.POPUP_UPGRADE_TEXT') }}
      </div>
      <div class="description mt-3">
        <ul class="list-unstyled">
          <li class="mb-3">
            Livestreaming, unlimited online products, and on-demand library
          </li>
          <li class="mb-3">
            Built-in community to move your memberships off Facebook
          </li>
          <li class="mb-3">
            Brand your studio in minutes, and integrate with your favorite
            platforms
          </li>
          <li>
            Premium Marvelous.bio features including no Tip jar commission fees
          </li>
        </ul>
      </div>
      <HMButton class="mt-4" color="brand">
        <a
          href="https://www.heymarvelous.com/upgrade-to-marvelous"
          target="_blank"
          class="undecorated-router-link"
          @click="$emit('close')"
        >
          {{ $t('BIO.BUTTON.LEARN_MORE') }}
        </a>
      </HMButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BioUpgradeModal',
  methods: {
    goToUpgrade() {
      this.$router.push({ name: 'bio-upgrade' });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.bio-upgrade-modal {
  padding: 2rem;
  background-color: lighten($coral, 30%);

  .text {
    font-weight: 500;
    font-size: 18px;
    color: $black;
  }

  .description {
    color: $black;
  }
}
</style>
